import { apiFetch } from "./client";
import type { Group, Page } from "./types";
import type { ListParams } from "./customers";

export interface GroupPayload {
  code: string;
  name: string;
  description?: string | null;
  permission_ids?: number[];
}

export async function listGroups(params: ListParams = {}): Promise<Page<Group>> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  const query = qs.toString();
  return apiFetch(`/groups${query ? `?${query}` : ""}`);
}

export async function getGroup(id: number): Promise<Group> {
  return apiFetch(`/groups/${id}`);
}

export async function createGroup(data: GroupPayload): Promise<Group> {
  return apiFetch("/groups", { method: "POST", body: JSON.stringify(data) });
}

export async function updateGroup(
  id: number,
  data: Partial<GroupPayload>,
): Promise<Group> {
  return apiFetch(`/groups/${id}`, { method: "PUT", body: JSON.stringify(data) });
}

export async function deleteGroup(id: number): Promise<unknown> {
  return apiFetch(`/groups/${id}`, { method: "DELETE" });
}
